export default "__VITE_ASSET__jwChThFK__"